import { NgControl } from "@angular/forms";

export function unmaskPhoneControl(model: NgControl) {
    const newVal = model.value.replace(/\D+/g, '');
    model.control.setValue(newVal, {
      emitEvent: true,
      emitModelToViewChange: true,
      emitViewToModelChange: true
    });
  }